export var MARKER_CLICK_FOCUS = {
  MARKER: 'marker',
  POPUP: 'popup'
};
export var DEFAULT_ZOOM_ON_CLICK_LEVEL = 14;
export default {
  MARKER_CLICK_FOCUS: MARKER_CLICK_FOCUS,
  DEFAULT_ZOOM_ON_CLICK_LEVEL: DEFAULT_ZOOM_ON_CLICK_LEVEL
};